import { formatScheduleTaskStatusLabel } from './scheduleTaskStatuses';

/**
 * Portrait tablet and narrow windows: the grid shrinks to the name column so the timeline is
 * visible (W-iP3). Width-based, not user-agent based.
 */
export const SCHEDULE_COMPACT_GRID_QUERY = '(orientation: portrait) and (max-width: 1100px)';

/** Status cell: friendly sentence case, and nothing on project group rows (W-M13, W-M5.4). */
export function scheduleGanttStatusText(status: unknown): string {
  const s = String(status ?? '').trim();
  if (!s || s === 'PROJECT') return '';
  return formatScheduleTaskStatusLabel(s);
}

export interface ScheduleGanttColumn {
  id: string;
  header: string;
  width: number;
  template?: (value: unknown) => string;
}

export function scheduleTaskGanttColumns(compact: boolean): ScheduleGanttColumn[] {
  if (compact) return [{ id: 'text', header: 'Task Name', width: 220 }];
  return [
    { id: 'text', header: 'Task Name / Resource', width: 260 },
    { id: 'taskNumber', header: 'Task ID', width: 140 },
    { id: 'plannedStartDate', header: 'Planned Start', width: 150 },
    { id: 'plannedCompletionDate', header: 'Planned End', width: 150 },
    { id: 'status', header: 'Status', width: 170, template: (v) => scheduleGanttStatusText(v) },
  ];
}
